export class Convert{
    constructor(){

    }
    static ToString(value){
        if (value == null)return '';
        return value;
    }

    static ToBoolean(value){
        if (value == null)return false;

        if (typeof value == 'boolean'){
            return value;
        }
        else
        {
            return value == 'true';
        }
    }

    static ToInt(value){
        if (value == null)return 0;

        if (typeof value == 'number'){
            return value;
        }

        return window.parseInt(value);
    }
}